import { render, staticRenderFns } from "./BookPost.vue?vue&type=template&id=6f5a556b&"
import script from "./BookPost.vue?vue&type=script&lang=js&"
export * from "./BookPost.vue?vue&type=script&lang=js&"
import style0 from "./BookPost.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports